/**
 * Australian date formatting helpers — dd/mm/yyyy.
 *
 * Use these everywhere a date is shown to a user so the format is consistent
 * regardless of the viewer's browser locale (a venue admin on a US-locale
 * machine would otherwise see mm/dd/yyyy from toLocaleString()).
 *
 * Accepts ISO strings (yyyy-mm-dd or a full ISO timestamp), Date objects, or
 * anything `new Date()` understands. Plain date-only strings are parsed by
 * their components to avoid a timezone off-by-one. Empty/invalid input returns
 * the `fallback` (an em dash by default).
 */
const pad = (n) => String(n).padStart(2, "0");

export function formatDateAU(value, fallback = "—") {
  if (value === null || value === undefined || value === "") return fallback;
  // Date-only string (yyyy-mm-dd[...]) — build from parts so the displayed day
  // never shifts across timezones.
  const m = typeof value === "string" && /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
  const d = m ? new Date(+m[1], +m[2] - 1, +m[3]) : new Date(value);
  if (Number.isNaN(d.getTime())) {
    return m ? `${m[3]}/${m[2]}/${m[1]}` : String(value);
  }
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
}

export function formatDateTimeAU(value, fallback = "—") {
  if (value === null || value === undefined || value === "") return fallback;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  let h = d.getHours();
  const ampm = h >= 12 ? "pm" : "am";
  h = h % 12 || 12;
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}, ${h}:${pad(d.getMinutes())} ${ampm}`;
}
